import React, { useEffect, useState } from "react";
import homeVideo from "../assets/OdontoiatriaSgarbini.mp4";

const HomePageVideo = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className={`
        transition-all duration-700
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}        
      `}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="w-full h-auto object-cover z-0 pointer-events-none"
      >
        <source src={homeVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>     
    </div>
  );
};

export default HomePageVideo;
